import { render, staticRenderFns } from "./Amministrazione.vue?vue&type=template&id=0d5a4fe1&scoped=true&"
import script from "./Amministrazione.vue?vue&type=script&lang=js&"
export * from "./Amministrazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5a4fe1",
  null
  
)

export default component.exports